/* @flow */

import * as React from 'react';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Grid from '@material-ui/core/Grid';

//----------------------------------------------------------------------//
// CSS                                                                  //
//----------------------------------------------------------------------//

import styles from './FinderGrid.module.scss';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

type TypeProps = {
  children: React.Node,
};

export default class FinderGrid extends React.Component<*> {
  render(): React.Element<*> {
    const { children }: TypeProps = this.props;

    return (
      <Grid
        className={styles['finder-grid']}
        container={true}
        justify="center"
        spacing={0}
        alignItems="stretch"
        alignContent="stretch"
      >
        {children}
      </Grid>
    );
  }
}
